import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';

import QuerySnapshot = firebase.firestore.QuerySnapshot;
import DocumentReference = firebase.firestore.DocumentReference;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;
import Firestore = firebase.firestore.Firestore;

const firebaseInstance = firebase.initializeApp({
    apiKey: 'AIzaSyBplzGyhQd622ka7HEvIEFY32MOIPPH4KI',
    authDomain: 'abstractavatars.firebaseapp.com',
    databaseURL: 'https://abstractavatars.firebaseio.com',
    projectId: 'abstractavatars',
    storageBucket: 'abstractavatars.appspot.com',
    messagingSenderId: '289646002601',
    appId: '1:289646002601:web:ff7f713a1584993de084b8'
});

export const functions = firebaseInstance.functions();
export const db = firebaseInstance.firestore();

// if (process.env.NODE_ENV === 'development') {
//     functions.useFunctionsEmulator('http://localhost:5000');
//
//     db.settings({
//         host: 'localhost:8081',
//         ssl: false
//     });
// }

const { Timestamp, GeoPoint } = firebase.firestore;
export {
    Timestamp,
    GeoPoint,
    QuerySnapshot,
    DocumentReference,
    Firestore,
    QueryDocumentSnapshot
};
